export default __webpack_public_path__ + "static/media/vegan-subscription-boxes.2fc8c047.png";